import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';

import Button from '../../common/Button';
import Input from '../../common/Input';

const InputEmail = (field) => (
  <Input
    autoComplete="username"
    disabled
    type="email"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);
const InputPassword = (field) => (
  <Input
    autoComplete="current-password"
    type="password"
    value={field.input.value}
    onChange={(e) => field.input.onChange(e.target.value)}
    name={field.input.name}
    {...field}
  />
);

let Form = ({ handleSubmit, onSubmit, submitting, error, okButtonText, t }) => (
  <form onSubmit={handleSubmit} className="u-text-center">
    <div
      className="o-box o-box--huge c-box c-box--outlined u-margin-bottom-large"
      style={{ maxWidth: '430px', margin: '0 auto' }}
    >
      <Field
        component={InputEmail}
        name="email"
        placeholder={t('general.email')}
      />
      <Field
        component={InputPassword}
        name="password"
        placeholder={t('invite.accept.password')}
      />

      <div className="u-margin-top u-text-center">
        <Button disbaled={submitting ? 1 : 0} type="submit">
          {submitting ? t('general.sending') : t('general.activate')}
        </Button>
      </div>

      {error && <p className="c-alert c-alert--danger u-margin-top">{error}</p>}
    </div>
  </form>
);

Form = reduxForm({ form: 'invite-accept' })(translate()(Form));

export default Form;



// WEBPACK FOOTER //
// ./src/invite/accept/Form.js